import ForgetPasswordContainer from "../../../Components/Authentication/ForgetPassword";

const ForgetPassword = () => {
  return <ForgetPasswordContainer />;
};

export default ForgetPassword;
